import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import {
  HelpAndSupportLink,
  HelpAndSupportText,
  HelpContainer,
  HelpTitle,
  LightText,
} from './SingleOrder.styles'
import { AlertModal } from '@src/components/Modal/AlertModal'

import { singleOrderCustomType } from './queries/getSingleOrderCustomType'
import { activeOrderStatuses } from '@src/hooks/useHasActiveOrders'
import { useMarketplace } from '@src/hooks/useMarketplace'
import { ButtonType } from '../../components/Button'

export const HelpAndSupport: React.FC<{ order: singleOrderCustomType }> = ({
  order,
}) => {
  const { t } = useTranslation('helpAndSupport')
  const navigate = useNavigate()
  const marketplace = useMarketplace()

  const [outletSupportModalOpen, setOutletSupportModalOpen] = useState(false)
  const outletName = order.outlet.displayName
  const outletPhone = order.outlet.outletPhone

  const isActiveOrder =
    order.orderStatus !== null &&
    activeOrderStatuses.includes(order.orderStatus)

  const handleSupportClick = () => {
    if (isActiveOrder) {
      setOutletSupportModalOpen(true)
    } else {
      const searchParams = new URLSearchParams()
      searchParams.set('account', 'help')
      searchParams.set('accountChild', 'support')

      if (order.orderNumber) {
        searchParams.set('orderNumber', order.orderNumber)
      }

      navigate(`?${searchParams.toString()}`)
    }
  }

  return (
    <HelpContainer>
      <HelpTitle>{t('help_and_support')}</HelpTitle>
      <LightText>
        {t('check_out_our')}{' '}
        <HelpAndSupportText>
          <HelpAndSupportLink
            onClick={() => navigate('?account=help&accountChild=faqs')}
          >
            {t('help_and_support')}
          </HelpAndSupportLink>
        </HelpAndSupportText>{' '}
        {t('section_or_contact')}
        <HelpAndSupportText>
          {' '}
          <HelpAndSupportLink onClick={handleSupportClick}>
            {order.outlet.active && isActiveOrder
              ? order.outlet.displayName
              : marketplace.name}{' '}
            {t('customer_support')}
          </HelpAndSupportLink>
        </HelpAndSupportText>
      </LightText>
      {outletSupportModalOpen && (
        <AlertModal
          isOpen={outletSupportModalOpen}
          title={t('problem_with_order')}
          desc={t('contact_outlet_subtext', { outletName })}
          onClose={() => setOutletSupportModalOpen(false)}
          closeTriggersCancel={false}
          headerBackgroundColor="#f6f6f9"
          showCloseButton
          action={{
            text: `Call ${order.outlet.displayName}`,
            onClick: () => {
              window.open(`tel:${outletPhone}`, '_self')
            },
            intent: ButtonType.SECONDARY,
          }}
          isLeftSidebar={false}
          showFAQs={marketplace.featureFAQ || false}
          smallHeader
        />
      )}
    </HelpContainer>
  )
}
